import { CFIconArchive } from './archive';
import { CFIconAt } from './at';
import { CFIconEmail } from './email';
import { CFIconInbox } from './inbox';
import { CFIconMessageCircle } from './message-circle';
import { CFIconMessageSquare } from './message-square';
import { CFIconPaperPlane } from './paper-plane';
import { CFIconPhone } from './phone';
import { CFIconPhoneCall } from './phone-call';
import { CFIconPhoneMissed } from './phone-missed';
import { CFIconPhoneOff } from './phone-off';
export const CFIconGroupCommunication = [
    CFIconArchive,
    CFIconAt,
    CFIconEmail,
    CFIconInbox,
    CFIconMessageCircle,
    CFIconMessageSquare,
    CFIconPaperPlane,
    CFIconPhone,
    CFIconPhoneCall,
    CFIconPhoneMissed,
    CFIconPhoneOff,
];
